import api from './axios';
import { setToken, setRefreshToken } from '../utils/token';

export const authAPI = {
  /**
   * Вход в систему
   * @param {string} email 
   * @param {string} password 
   * @returns {Promise} Ответ сервера с токенами
   */
  login: async (email, password) => {
    const response = await api.post('/api/v1/auth', { email, password });
    
    // Сохраняем токены
    if (response.data.accessToken) {
      setToken(response.data.accessToken);
    }
    if (response.data.refreshToken) {
      setRefreshToken(response.data.refreshToken);
    }
    
    return response.data;
  },

  /**
   * Регистрация нового пользователя
   * @param {string} email 
   * @param {string} password 
   * @returns {Promise} Ответ сервера с созданным пользователем
   */
  register: async (email, password) => {
    const response = await api.post('/api/v1/user', { email, password });
    return response.data;
  },

  /**
   * Валидация email
   * @param {string} email 
   * @returns {Promise} Ответ сервера с результатом валидации
   */
  validateEmail: async (email) => {
    const response = await api.get('/api/v1/user/validation', { params: { email } });
    return response.data;
  },

  /**
   * Обновление токена доступа
   * @param {string} refreshToken 
   * @returns {Promise} Новый токен доступа
   */
  refreshToken: async (refreshToken) => {
    const response = await api.post('/api/v1/auth/token/refresh', { refreshToken });
    return response.data;
  },

  /**
   * Выход из системы
   */
  logout: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
  }
};
